import { TaskType } from "../task/model";

import * as actions from "./actionTypes";
import { BbvReportSuccessorTasksLoadedSuccess } from "./actions";

export function bbvReportSuccessorTasks(
    state: TaskType[] = [],
    action: BbvReportSuccessorTasksLoadedSuccess): TaskType[] {
    switch (action.type) {
        case actions.BBV_REPORT_SUCCESSOR_TASKS_LOAD_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
